"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const react_1 = __importStar(require("react"));
const react_innertext_1 = __importDefault(require("react-innertext"));
const delete_1 = require("../chip/delete");
const styled_1 = require("../text-field/styled");
const styled_2 = require("./styled");
exports.Dropdown = (0, react_1.forwardRef)((_a, ref) => {
    var { children, onChange, onFocus, autoComplete = "off", maxHeight } = _a, props = __rest(_a, ["children", "onChange", "onFocus", "autoComplete", "maxHeight"]);
    const inputRef = (0, react_1.useRef)(ref);
    const [showPopup, setShowPopup] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)("");
    const { disabled, placeholder, variant, name = "dropdown" } = props;
    const variantName = disabled ? "disabled" : variant;
    const listName = `${name}-list`;
    const childrenArr = react_1.Children.toArray(children);
    const options = childrenArr.map((element) => {
        const { onClick, value } = element.props;
        const newOnclick = (e) => {
            onClick && onClick(e);
            setShowPopup(false);
            onChange && onChange(value);
        };
        return (0, react_1.cloneElement)(element, {
            onClick: newOnclick,
            tabIndex: 0,
        });
    });
    const selected = options.find(({ props }) => props.selected);
    (0, react_1.useEffect)(() => {
        const enterListener = (function () {
            function listener(e) {
                var _a;
                const target = e.target;
                !((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)) && setShowPopup(false);
            }
            window.addEventListener("click", listener);
            return function removeListener() {
                window.removeEventListener("click", listener);
            };
        })();
        return () => {
            enterListener();
        };
    }, [inputRef]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_2.StyledDropdown, Object.assign({}, props, { placeholder: placeholder, autoComplete: autoComplete, list: listName, ref: inputRef, onFocus: (e) => {
                setShowPopup(true);
                onFocus && onFocus(e);
            }, onChange: (e) => {
                e.stopPropagation();
                e.preventDefault();
                const { value = "" } = e.currentTarget;
                const search = value.toLowerCase();
                setSearch(search);
            } }),
            selected && (react_1.default.createElement(delete_1.ChipDelete, { "data-testid": "icon-value", variant: variantName, disabled: disabled, onClick: (e) => {
                    onChange && onChange();
                } }, selected.props.children)),
            react_1.default.createElement(styled_1.IconRight, { name: "chevron", rotate: showPopup ? "top" : "bottom", onClick: (e) => {
                    if (disabled)
                        return;
                    e.stopPropagation();
                    setShowPopup(!showPopup);
                } })),
        showPopup && (react_1.default.createElement(styled_2.StyledDropdownPopup, { alignH: "center", alignV: "bottom", observe: "width", onClose: () => setShowPopup(false), relatedRef: inputRef, "data-testid": "dropdown-popup", relatedParent: true, onBlur: (e) => {
                var _a;
                if (!((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)))
                    setShowPopup(false);
            } },
            react_1.default.createElement(styled_2.StyledDatalist, { id: listName, "data-testid": "popup-datalist", maxHeight: maxHeight }, search
                ? options.filter((item) => {
                    return !!~(0, react_innertext_1.default)(item).toLowerCase().indexOf(search);
                })
                : options)))));
});
//# sourceMappingURL=main.js.map